import './styles.scss';

const CoreSection = ({ section, isFirst }) => {
    const { header, body, images, videos, sequence, mediaStacked, ctaUrl, ctaText } = section;

    // Determine if image should be on left or right based on sequence (alternating)
    const imageOnLeft = sequence % 2 === 0;

    // Stacked layout: vertical centered text and media
    if (mediaStacked) {
        const imageCount = images?.length || 0;

        return (
            <div className={`core-section stacked ${isFirst ? 'first-section' : ''}`}>
                {isFirst && <div className="decorative-line"></div>}
                <div className="core-content-stacked">
                    <div className="core-text-centered">
                        {header && <h2>{header}</h2>}
                        {body && <div className={!header ? 'body-as-heading' : ''} dangerouslySetInnerHTML={{ __html: body }} />}
                        {ctaUrl && ctaText && (
                            <a href={ctaUrl} className="cta gold-fill" target="_blank" rel="noopener noreferrer">
                                {ctaText}
                            </a>
                        )}
                    </div>
                    <div className={`core-media images-${imageCount}`}>
                        {videos && videos.length > 0 && (
                            <iframe
                                width="100%"
                                height="500"
                                src={videos[0].url}
                                title={header || 'Video'}
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                allowFullScreen
                            ></iframe>
                        )}
                        {!videos?.length && images && images.length === 1 && (
                            <img
                                src={`${process.env.REACT_APP_WEBSITE_API}/api/images/optimize?filePath=images/hero/core/${images[0].fileName}&width=1200&height=800&quality=90&format=webp`}
                                alt={header || 'Section image'}
                            />
                        )}
                        {!videos?.length && images && images.length > 1 && (
                            <div className="image-grid">
                                {images.slice(0, 4).map((image, index) => (
                                    <img
                                        key={index}
                                        src={`${process.env.REACT_APP_WEBSITE_API}/api/images/optimize?filePath=images/hero/core/${image.fileName}&width=600&height=450&quality=90&format=webp`}
                                        alt={`${header || 'Section image'} ${index + 1}`}
                                        className={`grid-image image-${index + 1}`}
                                    />
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }

    // Side-by-side layout
    const imageCount = images?.length || 0;

    return (
        <div className={`core-section ${imageOnLeft ? 'image-left' : 'image-right'} ${isFirst ? 'first-section' : ''}`}>
            {isFirst && <div className="decorative-line"></div>}
            <div className="core-content">
                <div className="core-text">
                    {header && <h2>{header}</h2>}
                    {body && <div className={!header ? 'body-as-heading' : ''} dangerouslySetInnerHTML={{ __html: body }} />}
                    {ctaUrl && ctaText && (
                        <a href={ctaUrl} className="cta gold-fill " target="_blank" rel="noopener noreferrer">
                            {ctaText}
                        </a>
                    )}
                </div>
                <div className={`core-image images-${imageCount}`}>
                    {images && images.length === 1 && (
                        <img
                            src={`${process.env.REACT_APP_WEBSITE_API}/api/images/optimize?filePath=images/hero/core/${images[0].fileName}&width=800&height=600&quality=90&format=webp`}
                            alt={header || 'Section image'}
                        />
                    )}
                    {images && images.length > 1 && (
                        <div className="image-grid">
                            {images.slice(0, 4).map((image, index) => (
                                <img
                                    key={index}
                                    src={`${process.env.REACT_APP_WEBSITE_API}/api/images/optimize?filePath=images/hero/core/${image.fileName}&width=600&height=450&quality=90&format=webp`}
                                    alt={`${header || 'Section image'} ${index + 1}`}
                                    className={`grid-image image-${index + 1}`}
                                />
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default CoreSection;
